import { api } from "../../Config/ApiConfig";

export const register = async (userData) => {
    const { data } = await api.post('/auth/register', userData);
    return data;
};